import React, { useState } from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import CreditDebitDetailsForm from "./CreditDebitDetailsForm";

const SubscriptionsModal = ({ CloseModal, setSubDetailsModal, setInvoice }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };
  return (
    <>
      <div
        className={`modal-wrapper overflow-y-auto ${
          selectedOption === "creditDebitCard" ? "h-full" : ""
        }`}
      >
        <div
          className={`side-modal w-[50%] ${
            selectedOption === "creditDebitCard" ? "" : "h-screen"
          }`}
        >
          <div className="flex mt-10 mb-8 justify-center">
            <div className="flex w-[70%] justify-between">
              <p className="text-[#2F80ED]">Payment Methods</p>
              <div onClick={CloseModal} className="cursor-pointer">
                <img src={cross_icon} alt="cross icon"/>
              </div>
            </div>
          </div>

          {/* Credit / Debit Card */}
          <div className="flex justify-center ">
            <div className="flex w-[70%]">
              <input
                type="radio"
                className="w-4"
                name="paymentMethod"
                checked={selectedOption === "creditDebitCard"}
                onChange={() => handleOptionChange("creditDebitCard")}
              />
              <p className="ml-4 text-[16px]">Credit / Debit Card</p>
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <div className="w-[70%]">
              <hr />
            </div>
          </div>
          {/* Credit / Debit Details Form */}

          <div className="flex justify-center">
            {selectedOption === "creditDebitCard" ? (
              <CreditDebitDetailsForm
                setSubDetailsModal={setSubDetailsModal}
                setInvoice={setInvoice}
              />
            ) : (
              ""
            )}
          </div>

          {/* UPI Payments */}
          <div className="flex justify-center mt-4">
            <div className="flex w-[70%]">
              <input
                type="radio"
                className="w-4"
                name="paymentMethod"
                checked={selectedOption === "upiPayments"}
                onChange={() => handleOptionChange("upiPayments")}
              />
              <p className="ml-4 text-[16px]">UPI Payments</p>
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <div className="w-[70%]">
              <hr />
            </div>
          </div>
          {/* Internet Banking */}
          <div className="flex justify-center mt-4">
            <div className="flex w-[70%]">
              <input
                type="radio"
                className="w-4"
                name="paymentMethod"
                checked={selectedOption === "internetBanking"}
                onChange={() => handleOptionChange("internetBanking")}
              />
              <p className="ml-4 text-[16px]">Internet Banking</p>
            </div>
          </div>
          <div className="flex justify-center mt-4 mb-8">
            <div className="w-[70%]">
              <hr />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionsModal;
